module.exports = __webpack_public_path__ + "img/bi-marketplace-2.870d9c81.png";